import {SET_TOKENS, GET_TOKENS, CLEAR_TOKENS} from "./actionTypes";

export const getTokens = () => {
    return {
        type: GET_TOKENS,
        payload: {}
    };
};

export const setTokens = ({ tokens, error }) => {
    return {
        type: SET_TOKENS,
        payload: { tokens, error }
    };
};

export const clearTokens = () => {
    return {
        type: CLEAR_TOKENS,
        payload: {}
    };
};
